import React from 'react'
import {Link, graphql, useStaticQuery} from 'gatsby'
import Layout from '../components/layout'
import * as blogStyles from './pageStyles/blog.module.scss'
import Head from '../components/head'
const BlogPage = () => {
    const data = useStaticQuery(graphql`
        query{
                allMdx(
                    sort: {fields: [frontmatter___date], order: DESC}, 
                    filter: { frontmatter: { published: { eq: true } } }
                ) {
                    edges {
                    node {
                        frontmatter {
                        title
                        date(formatString: "MMMM Do, YYYY")
                        tags
                        published
                        }
                        fields {
                        slug
                        }
                        timeToRead
                    }
                    }
                }
                }
    `)
    //console.log(data)
    return (
        <Layout>
            <Head title="Blog" />
            <div className={blogStyles.content}>
            <ol style={{marginTop: -10}} className={blogStyles.posts}>
                <li className={blogStyles.tagLink}>
                    <Link to={`/tags`}>
                        <h3>{`All Tags`}</h3>
                    </Link>
                </li>
                {data.allMdx.edges.map((edge, index)=>{
                    return(
                        <li key={index} className={blogStyles.post}>
                            <Link to={`/blog/${edge.node.fields.slug}`}>
                                <h2>{edge.node.frontmatter.title}</h2>
                                <div>{edge.node.frontmatter.tags.map((tag, index) => {
                                  return (<span key={index}>{tag}</span>)
                                })}</div>
                                <p>{edge.node.frontmatter.date} ~ Est. {edge.node.timeToRead} min read</p>
                            </Link>
                        </li>
                    )
                })}
            </ol>
            </div>
        </Layout>
    )
}
export default BlogPage
